import type { SEOFooter } from '@ps/web-martech-cms-types';
import { StarsButton } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useState } from 'react';

import { CMSHTML } from '@swf/cms';
import Arrow from '@swf/core/assets/icons/arrow.svg';

import { TXTCLI_Show_Less_1, TXTCLI_Show_More_2 } from './CMSSEOFooter.messages.json';
import styles from './CMSSEOFooter.scss';

const CMSSEOFooter: React.FC<SEOFooter> = ({ content, fadable }) => {
  const [faded, setFaded] = useState(fadable);

  if (content.length === 0) {
    return null;
  }

  const toggleFaded = () => setFaded(!faded);

  return (
    <section className={classNames(styles.seoFooter, { [styles.fadable]: fadable })}>
      <div className={styles.container}>
        <div className={classNames(styles.content, { [styles.faded]: faded })}>
          {content.map((html, i) => (
            <CMSHTML key={i} {...html} className={styles.html} />
          ))}
          {faded && <div className={styles.gradient} />}
        </div>
        {fadable && (
          <StarsButton
            block
            className={styles.toggleFadeBtn}
            icon={<Arrow className={classNames({ [styles.upArrow]: !faded })} />}
            iconPosition="after"
            onClick={toggleFaded}
            size="small"
            translation={faded ? TXTCLI_Show_More_2 : TXTCLI_Show_Less_1}
            variant="text"
          />
        )}
      </div>
    </section>
  );
};

export default CMSSEOFooter;
